var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "49.000000pt",
    height: "74.000000pt",
    viewBox: "0 0 49.000000 74.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,74.000000) scale(0.100000,-0.100000)",
    fill: "#a51713",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 726 c-37 -16 -70 -52 -84 -89 -7 -17 -11 -123 -11 -270 0 -232 1 -244 23 -282 36 -65 88 -85 223 -85 136 0 184 19 221 90 22 42 23 52 23 279 0 226 -1 239 -22 281 -37 73 -78 90 -223 89 -78 0 -131 -4 -150 -13z m275 -71 c46 -24 52 -63 48 -307 l-3 -218 -28 -27 c-25 -26 -35 -28 -119 -32 -51 -2 -108 2 -130 8 -64 20 -68 38 -68 293 0 239 4 262 50 285 37 19 213 17 250 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 186 c-3 -8 -4 -23 -2 -33 3 -16 15 -18 113 -18 108 0 110 0 113 24 2 13 -2 28 -10 32 -7 5 -57 9 -111 9 -76 0 -99 -3 -103 -14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFone);
export default __webpack_public_path__ + "static/media/fone.744a5154474a1507ede6452c4eb95e07.svg";
export { ForwardRef as ReactComponent };